import "./logging";

import merge from "lodash/fp/merge";

import { STAGE } from "@app/config/constants";

import createCommonConfig from "./config.common";
import developmentConfig from "./config.development";
import productionConfig from "./config.production";
import stagingConfig from "./config.staging";
import testConfig from "./config.test-env";
import initLogConfig from "./logging";

let environmentConfig;

switch (STAGE) {
  case "development":
    environmentConfig = developmentConfig;
    break;
  case "test":
    environmentConfig = testConfig;
    break;
  case "staging":
    environmentConfig = stagingConfig;
    break;
  case "production":
    environmentConfig = productionConfig;
    break;
  default:
    throw new Error(`Unknown stage: ${STAGE}`);
}

const commonConfig = createCommonConfig(environmentConfig);

const config = merge({ ...commonConfig }, environmentConfig);

initLogConfig(STAGE);

export default config;
